import React from "react";
import { Instagram, Facebook, Youtube } from "lucide-react";
import { SITE } from "../../lib/siteData";

const XIcon = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.244 2H21.5l-7.5 8.57L23 22h-6.844l-5.36-7.01L4.5 22H1.244l8.03-9.18L1 2h7.02l4.83 6.39L18.244 2zm-1.2 18h1.9L7.05 4H5.05l11.994 16z" />
  </svg>
);

const TikTokIcon = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.6 6.32a5.3 5.3 0 0 1-3.3-1.5 5.27 5.27 0 0 1-1.55-3.32h-3.16v13.18a2.62 2.62 0 1 1-2.62-2.62c.27 0 .53.04.78.12V9.04a5.86 5.86 0 0 0-.78-.05 5.78 5.78 0 1 0 5.78 5.78V8.92a8.42 8.42 0 0 0 4.85 1.55V7.32a5.07 5.07 0 0 1-0 -1z" />
  </svg>
);

const ThreadsIcon = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.55 11.13c-.08-.04-.16-.07-.24-.1-.14-2.66-1.59-4.18-4.03-4.2-1.47-.01-2.7.62-3.45 1.78l1.36.93c.56-.85 1.44-1.03 2.08-1.03h.02c.8.01 1.4.24 1.79.7.28.33.47.79.56 1.38a10.2 10.2 0 0 0-2.32-.11c-2.34.14-3.85 1.5-3.75 3.4.05.96.53 1.79 1.34 2.33.69.46 1.57.68 2.5.63 1.21-.07 2.16-.53 2.83-1.37.5-.63.82-1.45.96-2.48.59.36.99.83 1.22 1.4.39.94.41 2.49-.85 3.74-1.1 1.1-2.43 1.58-4.43 1.59-2.22-.02-3.9-.73-4.99-2.11C9.74 16.36 9.3 14.6 9.28 12c.02-2.6.46-4.36 1.4-5.61 1.09-1.38 2.77-2.09 5-2.11 2.23.02 3.94.73 5.07 2.13.55.68.97 1.55 1.25 2.58l1.74-.47c-.34-1.27-.87-2.37-1.58-3.27C20.71 3.5 18.59 2.51 15.81 2.5h-.02c-2.77.01-4.88 1-6.27 2.95C8.29 7.18 7.69 9.32 7.67 12v.01c.02 2.67.62 4.81 1.85 6.55 1.39 1.95 3.5 2.95 6.27 2.96h.02c2.46-.01 4.2-.66 5.62-2.09 1.86-1.86 1.81-4.18 1.2-5.61-.45-1.04-1.3-1.88-2.45-2.43m-3.7 2.86c-1.04.06-2.11-.41-2.16-1.4-.04-.74.53-1.55 2.22-1.65l.41-.01c.55 0 1.06.05 1.53.16-.18 2.22-1.22 2.85-2 2.9" />
  </svg>
);

const ICONS = {
  instagram: Instagram,
  facebook: Facebook,
  youtube: Youtube,
  x: XIcon,
  tiktok: TikTokIcon,
  threads: ThreadsIcon,
};

export default function SocialIcons({ size = 14, className = "", linkClassName = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="social-icons">
      {SITE.socials.map((s) => {
        const Icon = ICONS[s.icon];
        return (
          <a
            key={s.name}
            href={s.href}
            target="_blank"
            rel="noreferrer noopener"
            aria-label={s.name}
            data-testid={`social-${s.icon}`}
            className={`inline-flex items-center justify-center transform-gpu transition-all duration-300 ease-out hover:scale-125 hover:-translate-y-1 hover:drop-shadow-[0_4px_12px_rgba(1, 18, 51,0.45)] ${linkClassName}`}
          >
            <Icon size={size} />
          </a>
        );
      })}
    </div>
  );
}
